import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { CheckCircle, Calendar, ArrowRight, Home } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import { DemoScheduler } from '@/components/scheduling';

export const PricingAssessmentSuccess: React.FC = () => {
  const navigate = useNavigate();

  const handleHomeClick = () => {
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-gray-50 py-16">
      <div className="container mx-auto px-4">
        {/* Success Header */}
        <div className="text-center mb-12">
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <CheckCircle className="w-12 h-12 text-green-600" />
          </div>
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Assessment Complete!</h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Thank you for providing details about your community. We're now ready to show you
            exactly how the Community App platform will work for your specific needs.
          </p>
        </div>

        <div className="max-w-4xl mx-auto grid md:grid-cols-2 gap-8">
          {/* Scheduler Component */}
          <div>
            <DemoScheduler
              source="pricing-silver" // This will be dynamically set based on the tier
              onAssessmentRequired={(redirectUrl) => {
                console.log('Assessment required, redirecting to:', redirectUrl);
              }}
              onDemoAccessed={() => {
                console.log('Demo scheduling accessed');
              }}
            />
          </div>

          {/* What's Next Section */}
          <div className="space-y-6">
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <Calendar className="w-5 h-5 text-blue-600" />
                  What Happens Next
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <div className="space-y-3">
                  <div className="flex items-start gap-3">
                    <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded text-sm font-medium">
                      1
                    </span>
                    <div>
                      <p className="font-medium text-gray-900">Schedule Your Demo</p>
                      <p className="text-gray-600 text-sm">
                        Pick a convenient time for your personalized walkthrough
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded text-sm font-medium">
                      2
                    </span>
                    <div>
                      <p className="font-medium text-gray-900">Demo Preparation</p>
                      <p className="text-gray-600 text-sm">
                        Our team reviews your assessment and prepares a custom demo
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded text-sm font-medium">
                      3
                    </span>
                    <div>
                      <p className="font-medium text-gray-900">Live Demo Call</p>
                      <p className="text-gray-600 text-sm">
                        45-minute session tailored to your community's needs
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <span className="bg-green-100 text-green-800 px-2 py-1 rounded text-sm font-medium">
                      4
                    </span>
                    <div>
                      <p className="font-medium text-gray-900">Custom Proposal</p>
                      <p className="text-gray-600 text-sm">
                        Receive detailed pricing and implementation plan
                      </p>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* Additional Actions */}
            <Card>
              <CardContent className="p-6">
                <h3 className="font-semibold text-gray-900 mb-4">Not Ready to Schedule Yet?</h3>
                <div className="space-y-3">
                  <Link to="/pricing" className="block">
                    <Button variant="outline" className="w-full justify-start">
                      <ArrowRight className="w-4 h-4 mr-2 rotate-180" />
                      Review Pricing Options
                    </Button>
                  </Link>

                  <Button
                    variant="outline"
                    onClick={handleHomeClick}
                    className="w-full justify-start"
                  >
                    <Home className="w-4 h-4 mr-2" />
                    Return to Homepage
                  </Button>
                </div>
              </CardContent>
            </Card>

            {/* Contact Information */}
            {/*<Card className="bg-blue-50 border-blue-200">
              <CardContent className="p-6 text-center">
                <h3 className="font-semibold text-blue-900 mb-2">Need Immediate Assistance?</h3>
                <p className="text-blue-800 text-sm mb-4">
                  Have questions or need to speak with someone right away?
                </p>
                {/* <a 
                  href="mailto:support@example.com"
                  className="text-blue-600 font-semibold hover:text-blue-700 underline"
                >
                  Email support@example.com
                </a> 
              </CardContent>
            </Card>*/}
          </div>
        </div>
      </div>
    </div>
  );
};
